module.exports = __webpack_public_path__ + "img/png-4.ae306396.png";